<template>

  <b-modal
      id="form-export"
      modal-class='form form-export'
      modal-footer="hide"
      scrollable
      centered
      :size="this.mode === 'delete'? 'md' : 'lg'"
      :title="this.title"
  >

    <div class="form form__export">
      <b-overlay
          id="overlay-challenge"
          :show="showMe"
          rounded="sm"
          variant="white"
          opacity='0.8'
          blur="2px"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
      >

        <!-- <b-form @submit="onSubmit" @reset="onReset"> -->
        <b-form v-if="mode === 'create' || mode === 'duplicate' || mode === 'see'" style="min-height: 500px;">
          <b-row>
            <b-col sm="12">
              <b-form-group
                  id="input-group-1"
                  :label="'Nom *'"
                  label-for="export-name"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  label-class="dw-18"
                  label-align="right"
              >
                <b-form-input
                    id="export-name"
                    v-model="form.name"
                    required
                    :state="nameState"
                    :placeholder="'Nom'"
                    :disabled="formDisabled"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12">
              <b-form-group
                  id="input-group-4"
                  :label="'Date du fichier *'"
                  label-for="export-category"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  label-class="dw-18"
                  label-align="right"
              >
                <b-form-select
                    v-model="form.monitoring"
                    :options="monitorings"
                    :disabled="formDisabled"
                    :state="monitoringState"
                    required
                    class="select"
                >
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="this.users.length > 1">
            <b-col sm="12">
              <b-form-group
                  id="input-group-4"
                  :label="'Commerciaux *'"
                  label-for="export-user"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  label-class="dw-18"
                  label-align="right"
              >
                <v-select label="text"
                          multiple
                          v-model='form.users'
                          class="select"
                          :disabled="formDisabled"
                          :options="users"
                          :state="userState"
                          placeholder="Rechercher un utilisateur ..."
                          ></v-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="mode !== 'see'">
            <b-col sm="12" class="align-item-center">
              <b-form-group
                  id="input-group-4"
                  :label="'Ajouter au favoris'"
                  label-for="export-favorite"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  label-class="dw-18"
                  label-align="right"
              >
                <b-form-checkbox
                    id="export-favorite"
                    v-model="form.favorite"
                    name="acceptedLaws"
                    :value="accepted"
                    :disabled="formDisabled"
                    unchecked-value="not_accepted"
                    class="mt-2"
                    :class="{error:notAccepted}"
                ></b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="mode !== 'see'">
            <b-col sm="12">
              <b-form-group
                  id="input-group-4"
                  :label="'Ajouter un critère'"
                  label-for="export-category"
                  label-cols-sm="3"
                  label-cols-lg="3"
                  label-class="dw-18"
                  label-align="right"
              >
                <div class="d-flex align-items-baseline">
                  <v-select appendToBody label="value" v-model='searchParentCategory' class="select" :disabled="formDisabled" :options="parentCategories" placeholder="Rechercher une catégorie ..." @input="setParentCategory"></v-select>

                  <v-select appendToBody label="value" v-model='searchCategory' class="select" :disabled="formDisabled" :options="categories" placeholder="Rechercher une catégorie ..." @input="setCategory"></v-select>
                </div>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <div class="d-flex align-items-baseline">
                <v-select appendToBody label="text" v-model='searchCriteria' class="select ml-3" :disabled="formDisabled" :options="criterias" placeholder="Rechercher un critère ..."></v-select>

                <b-button
                    @click="addCriteria()"
                    class="ml-3 btn-challenges btn-export form-group"
                    :class="{disabled:isLoading}"
                >
                  Ajouter
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col sm="3"></b-col>
            <b-col class="pl-2">
              <ul class="p-0" v-if="form.criterias.length > 0" style="padding-left: 10px;">
                <li class="bordered p-2 card-body d-flex justify-content-between align-items-center" v-for="(item, key) in form.criterias" :key="key">
                  <div class="col-4 p-0 text-truncate">
                    <strong>{{ item.category }}</strong>
                  </div>

                  <div class="col-4 p-0">
                    {{ item.criteria.text }}
                    <span v-if="item.criteria.value.includes('DTptf')" class="text-primary" style="font-size: 11px">Mis à jour mensuellement</span>
                  </div>

                  <div class="col-2">
                  </div>

                  <div class="col-2 justify-content-end d-flex p-0">
                    <Action :disabled=formDisabled @click.native="formDisabled ? null : removeCriteria(item)" :icon="'far fa-trash'" :mode="'danger'"></Action>
                  </div>
                </li>
              </ul>
            </b-col>
          </b-row>

          <div v-if="form.criterias.length === 0" class="w-100 mt-3 text-right">
            Aucun critère sélectionné ...
          </div>
        </b-form>

        <div v-if="mode === 'delete'">
          Voulez-vous supprimer l'export <strong>{{ getExportUpdated.item.name }}</strong> ? <br><br> Attention, la suppression est définitive.
        </div>
      </b-overlay>
    </div>

    <template v-slot:modal-footer>
      <b-button v-if="cancel" @click="closeMe()" class="btn-cancel">
        {{formContent.formBtCancel}}
      </b-button>

      <b-button
          @click="submit()"
          class="btn-challenges ml-auto"
          :class="{disabled:isLoading}"
          :disabled="isDisable()"
      >
        {{ action }}
      </b-button>
    </template>

  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ApiService from "@/services/ApiService";
import moment from "moment/moment";
import Action from "@/components/module/action/Action.vue";
import ApiAuthenticationService from "@/services/ApiAuthenticationService";


export default {
  name: "FormExport",
  components: {
    Action

  },
  data () {
    return {
      showMe: false,
      mode: null,
      formContent: null,
      form: {
        name: '',
        monitoring: '',
        users: '',
        favorite: '',
        category: '',
        categories: [],
        criterias: [],
      },
      monitoringDefault: '',
      monitoringDisabled: false,
      userDefault: '',
      userDisabled: false,
      users: [
        {
          value: '',
          text: 'Choisir ...',
          disabled: true,
        }
      ],
      categories: [
        {
          value: '',
          text: 'Toutes',
        }
      ],
      parentCategories: [
        {
          value: '',
          text: 'Toutes',
        }
      ],
      criterias: [],
      parametrages: null,
      monitorings: [
        {
          value: '',
          text: 'Choisir ...',
          disabled: true,
        }
      ],
      accepted: "accepted",
      notAccepted: false,
      action: 'Créer',
      cancel: true,
      isLoading: false,
      formShowState: true,
      formDisabled: false,
      id: null,
      title: 'Export',
      searchCategory: '',
      searchParentCategory: '',
      searchCriteria: '',
      categoryToAdd: '',
    }
  },

  computed: {
    ...mapGetters([
      'getGeneral',
      'getExportUpdated'
    ]),
    nameState() {
      return this.formShowState && this.form.name?.length > 2 ? true : null;
    },
    monitoringState() {
      return this.formShowState && this.form.monitoring !== '' ? true : null;
    },
    userState() {
      return this.formShowState && this.form.users.length !== 0 ? true : null;
    },
  },
  async created() {
    this.formContent = this.getGeneral;

    await ApiService.getCommercialApi().getCommercialsListing().then((data) => {
      if (data.data.length > 0) {
        data.data.forEach((item) => {
          this.users.push({
            value: item.id,
            text: item.fullName,
            disabled: false,
            selected: true,
          })
        })
      } else {
        this.form.users = [{value: ApiAuthenticationService.getCurrentUser().id}];
      }
    })

    await ApiService.getParametrageApi().list().then((data) => {
      console.log(data.data);
      Object.keys(data.data.categories).forEach((item) => {
        this.categories.push({
          value: item,
          text: item,
          disabled: false,
        })
      })
      this.categories.sort((a,b) => a.text.trim().localeCompare(b.text.trim()));

      Object.keys(data.data.parentCategories).forEach((item) => {
        this.parentCategories.push({
          value: item,
          text: item,
          disabled: false,
        })
      })
      this.parentCategories.sort((a,b) => a.text.trim().localeCompare(b.text.trim()));

      this.parametrages = data.data;

      this.loadAllCriterias();
    })

    await ApiService.getParcourirApi().getDates().then((data) => {
      if (data.data.length > 0) {
        data.data.forEach((item) => {
          this.monitorings.push({
            value: item.id,
            text: item.text,
            disabled: false,
          })
        })
      }
    })
  },
  methods:{
    closeMe(reload = false){
      this.cleanMe();
      this.$root.$emit('bv::hide::modal', 'form-export');

      if (reload) {
        this.$store.dispatch('setExportUpdated', {
          mode: 'reload'
        });
      }
    },
    isDisable() {
      if (this.mode === 'see') {
        return false;
      }

      if (this.mode === 'delete') {
        return false;
      }

      return !(this.formShowState && this.nameState && this.monitoringState && this.userState);
    },
    selectCategory(category) {
      this.form.category = category;
      this.criterias = this.getCriterias(category);
      this.criterias.sort((a,b) => a.text.trim().localeCompare(b.text.trim()));
    },
    selectParentCategory(category) {
      this.form.parentCategory = category;
      this.categories = [];
      this.criterias = [];
      Object.keys(this.parametrages.parentCategories[category]).forEach((item) => {
        this.categories.push({
          value: item,
          text: item,
          disabled: false,
        })
        this.criterias = [...this.criterias , ...this.getCriterias(item)];
      })
      this.criterias.sort((a,b) => a.text.trim().localeCompare(b.text.trim()));
      this.categories.sort((a,b) => a.text.trim().localeCompare(b.text.trim()));
    },
    setCategory() {
      if (!this.searchCategory.value?.includes(' - ')) {
        this.searchCategory.value = this.searchParentCategory.value + ' - ' + this.searchCategory.value;
      }
      if (!this.searchCategory || !this.searchCategory.value || !Object.keys(this.parametrages.categories)?.includes(this.searchCategory.value)) {
        this.criterias = this.getCriterias();
        this.criterias.sort((a,b) => a.text.trim().localeCompare(b.text.trim()));
        return;
      }

      this.selectCategory(this.searchCategory.value);
    },
    setParentCategory() {
      if (!this.searchParentCategory || !this.searchParentCategory.value || !Object.keys(this.parametrages.parentCategories)?.includes(this.searchParentCategory.value)) {
        this.searchCategory = null;
        this.selectedCriteria = null;
        this.criterias = this.getCriterias();
        this.categories = this.getFilteredCategories();
        this.criterias.sort((a,b) => a.text.trim().localeCompare(b.text.trim()));
        return;
      }

      this.selectParentCategory(this.searchParentCategory.value);
    },
    getCriterias(item) {
      if (item === '') {
        return this.getAllCriterias();
      }

      let criterias = [];

      if (!item?.includes(' - ')) {
        item = this.searchParentCategory.value + ' - ' + item;
      }

      Object.values(this.parametrages.categories[item]).forEach((criteria) => {
        criterias.push({
          value: criteria,
          text: this.parametrages.criteriasWithLabel[criteria],
          disabled: false,
        })
      })

      criterias.sort((a,b) => a.text.localeCompare(b.text));

      return criterias;
    },
    getAllCriterias() {
      let criterias = [];

      if (this.form.criterias.length > 0) {
        this.form.criterias.forEach((item) => {
          criterias.push(item.criteria.value);
        })

        return criterias;
      }

      return this.criterias;
    },
    loadAllCriterias() {
      Object.values(this.parametrages.criterias).forEach((item) => {
        this.criterias.push({
          value: item,
          text: this.parametrages.criteriasWithLabel[item],
          disabled: false,
        })
      })
      this.criterias.sort((a,b) => a.text.trim().localeCompare(b.text.trim()));
    },
    addCriteria() {
      if (this.searchCriteria.length < 3) {
        return;
      }

      if (this.form.criterias.filter((item) => {
        return item.criteria === this.searchCriteria;
      }).length > 0) {
        return;
      }

      Object.values(this.parametrages.categories).forEach((category, key)=> {
        if (category.includes(this.searchCriteria.value)) {
          this.categoryToAdd = Object.keys(this.parametrages.categories)[key];
        }
      });

      this.form.criterias.push({
        criteria: this.searchCriteria,
        category: this.categoryToAdd,
      })

      this.searchCriteria = '';
      this.categoryToAdd = '';
    },
    removeCriteria(criteria) {
      this.form.criterias = this.form.criterias.filter((item) => {
        return item.criteria !== criteria.criteria;
      })
    },
    async submit() {
      if (this.mode === 'delete') {
        await ApiService.getExportApi().remove(this.id).then(() => {
          this.closeMe(true);
        });
      }

      if (this.mode === 'create' || this.mode === 'duplicate') {
        let data = {
          name: this.form.name,
          users: this.form.users.map((item) => item.value),
          monitoring: this.form.monitoring,
          criterias: this.getAllCriterias(),
          favorite: this.form.favorite === 'accepted',
        }

        await ApiService.getExportApi().create(data).then(() => {
          this.closeMe(true);
        });
      }

      this.closeMe();
    },
    cleanMe() {
      if (this.users.length > 1) {
        this.form.users = [];
      }
      this.form.category = '';
      this.form.date = '';
      this.form.categories = [];
      this.form.favorite = '';
      this.form.name = '';
      this.form.monitoring = '';
      this.formDisabled = false;
      this.formShowState = true;
      this.form.criterias = [];
      this.searchCriteria = '';
      this.searchCategory = '';
    },
    moment: function (date,year) {
      return moment(date,year);
    },
  },

  watch: {
    getExportUpdated() {
      if (this.getExportUpdated === '') {
        return;
      }

      this.cleanMe();

      this.mode = this.getExportUpdated.mode;
      this.data = this.getExportUpdated.data;
      this.action = this.getExportUpdated.action;
      this.cancel = this.getExportUpdated.cancel;

      if (this.mode === 'see') {
        this.title = 'Détails de l\'export ';
        this.formDisabled = true;
        this.formShowState = false;
      }

      if (this.getExportUpdated && this.getExportUpdated.item !== undefined) {
        if (!this.form.users || this.form.users.length === 0) {
          this.form.users = this.getExportUpdated.item.users.map((element) => {
            return {value: element.id, text: element.fullName};
          });
        }

        this.form.monitoring = this.getExportUpdated.item.monitoring.id;
        this.form.name = this.getExportUpdated.item.name;
        this.form.favorite = this.getExportUpdated.item.favorite ? 'accepted' : 'not_accepted';

        this.getExportUpdated.item.criterias.forEach((criteria) => {
          for (let criteriaObject of this.criterias) {
            if (criteriaObject.value === criteria) {
              this.searchCriteria = criteriaObject;
              this.addCriteria();
              this.searchCriteria = '';
            }
          }
        });

        if (this.mode === 'delete') {
          this.id = this.getExportUpdated.item.id;
          this.title = 'Supprimer un export';
        }
      }

      if (this.mode === 'create') {
        this.title = 'Créer un export';

        if (this.users.length === 2) {
          this.users.shift();
          this.users[0].selected = true;
          this.form.users = [this.users[0]];
        }
      }

      if (this.mode === 'duplicate') {
        this.title = 'Dupliquer un export';
        this.form.favorite = 'not_accepted';
      }
    },
  },
}
</script>

